'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useId, } from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';
import { cx } from '../../../internal/cx.js';
import { useFieldControl } from '../form-field/index.js';
/**
 * An on/off setting that applies immediately. For choices that are submitted
 * with a form, prefer Checkbox.
 */
export const Switch = forwardRef(function Switch({ label, description, size = 'md', className, ...rest }, ref) {
    const auto = useId();
    const props = useFieldControl(rest);
    const id = props.id ?? `mn-switch-${auto}`;
    const descriptionId = description ? `${id}-description` : undefined;
    const control = (_jsx(SwitchPrimitive.Root, { ref: ref, ...props, id: id, "aria-describedby": cx(props['aria-describedby'], descriptionId), "data-size": size, className: cx('mn-switch', label ? undefined : className), children: _jsx(SwitchPrimitive.Thumb, { className: "mn-switch__thumb" }) }));
    if (!label)
        return control;
    return (_jsxs("div", { className: cx('mn-choice', 'mn-choice--switch', className), "data-disabled": props.disabled || undefined, children: [_jsxs("div", { className: "mn-choice__text", children: [_jsx("label", { htmlFor: id, className: "mn-choice__label", children: label }), description ? (_jsx("p", { id: descriptionId, className: "mn-choice__description", children: description })) : null] }), control] }));
});
//# sourceMappingURL=switch.js.map